<template>
  <div class="mobile-header">
    <router-link class="logo"
                 :to="{name:'home'}"
                 tag="div"
    >
      <img src="/static/img/logo-black.png" alt="">
    </router-link>
    <div class="hamburger-box" @click="toggle">
      <div class="hamburger" :class="{'open':isOpen}">
        <span class="hamburger-icon-a"></span>
        <span class="hamburger-icon-b"></span>
        <span class="hamburger-icon-c"></span>
      </div>
    </div>
    <nav class="nav" :class="{'open':isOpen}">
      <ul class="first-ul">
        <li v-for="(item,index) in navName" :key="item.firstName.id" @click.stop="openSecondMenu">
          <router-link class="first-name"
                       :to="item.children ? `/home`: item.firstName.link"
                       :data-index="index"
                       tag="div"
          >
            <span class="num">{{item.firstName.id}} ──</span>
            <span class="en">{{item.firstName.en}}</span>
            <span class="cn">{{item.firstName.cn}}</span>
            <i class="arrow" v-if="item.children && mobile()" :class="{'open': secondMenu == index}"></i>
          </router-link>
          <slideDown>
            <ul v-if="item.children" class="second-ul" :css="false" :key="index" v-show="secondMenu == index ">
              <li v-for="(subItem,index) in item.children" :key="index" @click.stop>
                <router-link class="second-name extend-click"
                             :to="subItem.secondName.link ? subItem.secondName.link : `#${index}`"
                             tag="div"
                >
                  <span class="s-en">{{subItem.secondName.en}}</span>
                  <span class="s-cn">{{subItem.secondName.cn}}</span>
                </router-link>
                <ul v-if="subItem.children" class="three-ul">
                  <li v-for="(tSubItem,index) in subItem.children" :key="index">
                    <router-link class="three-name" :to="tSubItem.threeName.link " tag="div">
                      <span class="t-en">{{tSubItem.threeName.en}}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </slideDown>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import slideDown from "common/js/slideDown"

  export default {
    name: 'v-mobile-header',
    components: {slideDown},
    data() {
      return {
        isOpen: false,
        secondMenu: null
      }
    },
    created() {
      let that = this;
      this.navName = [
        {
          firstName: {
            en: 'Home',
            cn: '首页',
            link: '/home',
            id: '01'
          }
        },
        {
          firstName: {
            en: 'Campaign',
            cn: '形象视觉',
            link: '',
            id: '02'
          },
          children: [
            {
              secondName: {
                en: 'Campaign',
                cn: '形象大片',
                link: ''
              },
              children: []
            },
            {
              secondName: {
                en: 'lookBook',
                cn: '经典搭配',
                link: ''
              },
              children: []
            },
            {
              secondName: {
                en: 'Shooting Tidbits',
                cn: '拍摄花絮',
                link: '/image/shootingTidbits'
              },
            },
          ]
        },
        {
          firstName: {
            en: 'News',
            cn: '新闻资讯',
            link: '',
            id: '03'
          },
          children: [
            {
              secondName: {
                en: 'Brand news',
                cn: '品牌新闻',
                link: '/news/brandNews'
              }
            },
            {
              secondName: {
                en: 'Fashion show',
                cn: '秀场直击',
                link: '/news/fashionShow'
              }
            },
            /*  {
                secondName: {
                  en: 'Star',
                  cn: '明星演绎',
                  link: '/news/star'
                },
              },
              {
                secondName: {
                  en: 'Stores open',
                  cn: '新店开业',
                  link: '/news/storesOpen'
                },
              }*/
          ]
        },
        {
          firstName: {
            en: 'About',
            cn: '关于品牌',
            link: '/about',
            id: '04'
          }
        },
        {
          firstName: {
            en: 'Stores',
            cn: '门店形象',
            link: '/stores',
            id: '05'
          }
        },
        {
          firstName: {
            en: 'Vip',
            cn: '会员尊享',
            link: '/vip',
            id: '06'
          }
        },
        {
          firstName: {
            en: 'Contact',
            cn: '联系我们',
            link: '/contact',
            id: '07'
          }
        }
      ];

      // 获取子菜单
      [84, 81].forEach(writeSubmenu);

      function writeSubmenu(id, index) {
        that.api.getSubmenu(id).then(function (response) {
          response.data.forEach(function (item) {
            that.navName[1].children[index].children.push({
              threeName: {
                en: item.title_en,
                link: '/image/' + (index === 0 ? 'campaign' : 'lookbook') + '?id=' + item.id
              }
            });
          });
        });
      }
    },
    watch: {
      $route() {
        if (this.$route.hash === '') {
          this.isOpen = false;
        }
      },
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
      },
      openSecondMenu(e) {
        let index = e.target.parentNode.getAttribute("data-index");
        this.secondMenu = this.secondMenu == index ? "" : index;
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "~common/scss/mixin.scss";

  .mobile-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: url(../assets/bj.jpg) no-repeat;
    z-index: 9999;
    display: flex;
    align-items: center;
    visibility: hidden;
    @include maxScreenWidth(768) {
      visibility: visible;
    }
    .logo {
      position: fixed;
      left: 20px;
      z-index: 99999;
      width: 120px;
    }
    .hamburger-box {
      width: 20px;
      height: 12px;
      position: fixed;
      right: 20px;
      z-index: 99999;
      cursor: pointer;
      transition: all 0.3s;
      .hamburger {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &.open {
          .hamburger-icon-a {
            transform: rotate(-45deg);
            transition-delay: 0.28s;
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
          }
          .hamburger-icon-b {
            margin-top: -1px;
            margin-bottom: -3px;
            opacity: 0;
          }
          .hamburger-icon-c {
            transform: rotate(45deg);
            transition-delay: 0.32s;
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
          }
        }
      }
      .hamburger-icon-a {
        transition: all 0.1s 0.1s cubic-bezier(0.55, 0.055, 0.675, 0.19);
      }
      .hamburger-icon-b {
        margin-bottom: 3px;
        margin-top: 3px;
        transition: all 0.15s 0.15s cubic-bezier(0.33333, 0.66667, 0.66667, 1);
      }
      .hamburger-icon-c {
        transition: all 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1);
      }
      .hamburger-icon-a, .hamburger-icon-b, .hamburger-icon-c {
        width: 20px;
        height: 2px;
        background-color: #000;
        display: block;
        border-radius: 4px;
      }
    }
    .nav {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../assets/bj.jpg") repeat;
      transition: all 0.5s;
      opacity: 0;
      visibility: hidden;
      z-index: 9999;
      @include maxScreenWidth(480) {
        overflow-y: scroll;
      }
      &.open {
        opacity: 1;
        visibility: visible;
      }
      .first-ul {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding-left: 20px;
        > li {
          margin-bottom: 20px;
          position: relative;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .first-name {
          &.cur-active.active {
            opacity: 0.7;
            .cn {
              opacity: 1;
            }
          }
          .num {
            color: #000;
            padding-right: 3px;
          }
          .en {
            font-size: 24px;
            font-weight: 700;
          }
          .cn {
            font-size: 14px;
            font-weight: 100;
            padding: 10px;
            @include maxScreenWidth(320) {
              padding: 2px;
            }
          }
        }
      }
      .second-ul {
        white-space: nowrap;
        position: relative;
        top: 12px;
        margin-left: 55px;
        > li {
          margin-bottom: 10px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .second-name {
          font-size: 14px;
          color: #000;
          &.cur-active.active {
            .s-cn {
              opacity: 0.5 !important;
            }
            .s-en {
              opacity: 0.5;
            }
          }
          .s-en {
            opacity: 1;
            padding-left: 10px;
          }
          .s-cn {
            padding-left: 5px;
          }
        }
      }
      .three-ul {
        padding-left: 30px;
        font-size: 12px;
        line-height: 24px;
        .three-name.cur-active {
          opacity: 0.5;
        }
      }
      .arrow {
        display: inline-block;
        position: relative;
        width: 20px;
        height: 20px;
        transition: transform 0.3s;
        top: 5px;
        &.open {
          &:after {
            content: "-";
          }
        }
        &:after {
          content: "+";
          position: absolute;
          padding: 0;
          color: #000;
          font-size: 18px;
          font-style: normal;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VMobileHeader.vue